<!-- [appendTo]="appentTo ? appentTo : 'body'" -->
<p-overlayPanel #op
    [dismissable]="true"
    (onShow)="onShow()"
    (onHide)="onHide()">
    <input type="text"
           #domCampo
           name="domCampo"
           id="domCampo"
           [placeholder]="placeholder"
           [(ngModel)]="campo"
           (keyup.enter)="onEnter($event);"
           (keyup.esc)="onEsc($event);"
           pInputText>
           <!-- (focus)="event.target.select()" -->
</p-overlayPanel>
